
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Logon from './components/logon/Logon.js';

import EsqueciMinhaSenha from './components/esqueceu-senha/EsqueceuSenha.js';

import DashboardPortal from './components/portal/dashboard-portal/Dashboard.js';
import Usuarios_portal from './components/portal/usuarios-portal/Usuarios.js';

import DashboardIndicadores from './components/gestao/dashboard-indicadores/Dashboard.js';

import Usuarios from './components/gestao/usuarios-indicadores/Usuarios.js';
import Equipamentos_servico from './components/gestao/modulo-indicadores/Modulo.js';
import Acessos from './components/gestao/acessos-indicadores/Acessos.js';

import Dashboard_gerenciamento from './components/painel-monitoramento/dashboard-gerenciamento-projetos/Dashboard.js';

import Treinamento from './components/treinamento/Treinamento.js';

import Planejamento_entressafra from './components/planejamento-entressafra/Dashboard.js';

import BoletimExterno from './components/boletinsExterno/dashboard-boletins/Dashboard.js';

import BoletimBiomassa from './components/boletinsExterno/dashboard-boletins-biomassa/Dashboard.js';

import AceitacaoCDC from './components/aceitacao-cdc/Dashboard.js';

import ControleReagentes from './components/controle-reagentes/ControleReagentes.js';

import AcompanhamentoOS from './components/acompanhamentoOS/AcompanhamentoOS.js';

import CentralTi from './components/central-ti/CentralTi.js';

// function RedirectToExternal() {
//     // Redireciona imediatamente
//     window.location.href = 'https://hml.cooperval.coop.br/';
//     // Opcional: mostra uma mensagem enquanto redireciona
//     return <div>Redirecionando para o sistema de login...</div>;
// }

function App() {
    return (
        <Router>

            <Routes>






                <Route path="/login" element={<Logon />} />
                <Route path="/esqueci-minha-senha" element={<EsqueciMinhaSenha />} />

                <Route exact path="/" element={<DashboardPortal />} />

                <Route path="/gestao/" element={<DashboardIndicadores />} />
                <Route path="/gestao/cadastro-usuarios" element={<Usuarios />} />
                <Route path="/gestao/cadastro-url" element={<Equipamentos_servico />} />
                <Route path="/gestao/acessos" element={<Acessos />} />

                <Route path="/painel-de-monitoramento/" element={<Dashboard_gerenciamento />} />

                <Route path="/boletim-agricola/" element={<Navigate to="/boletim/" replace />} />

                <Route path="/boletim/" element={<BoletimExterno />} />

                <Route path="/boletim-biomassa/" element={<BoletimBiomassa />} />

                <Route path="/aceitacao-cdc/" element={<AceitacaoCDC />} />

                <Route path="/ordem-servico-oficina/" element={<AcompanhamentoOS />} />

                <Route path="/treinamento/" element={<Treinamento />} />

                <Route path="/planejamento-entressafra/" element={<Planejamento_entressafra />} />

                <Route path="/controle-reagentes/" element={<ControleReagentes />} />

                <Route path="/central-ti/" element={<CentralTi />} />


                <Route exact path="/" element={<DashboardPortal />} />
                <Route path="/cadastro-usuarios" element={<Usuarios_portal />} />


            </Routes>
        </Router>

    )
}
export default App;

